export const onKeyDown = (event: KeyboardEvent, measureCode: any, week?: any): any => {
  if (measureCode && measureCode.indexOf('Comment') < 0) {
    const keys = ['Backspace', 'ArrowRight', 'ArrowLeft', '-', 'Enter', 'Tab', 'Delete'];
    const currentInput = (event.target as any).value;
    return keys.includes(event.key) ||
      (event.key === '.' && currentInput.indexOf('.') < 0) ||
      event.key.match(/^\d+(\.\d+)?$/)
      ? true
      : false;
  }
};
